import { Navigate, Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";

const ProtectedLayout = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
    <Navbar />
    <Outlet />
    </>
  )
};

export default ProtectedLayout;
